export var typescriptVersion = "3.7.3";
